<template>
  <div>
    <b-table
        striped hover
        small
        sticky-header="50vh"
        selectable
        select-mode="single"
        :items="docsEkp"
        :fields="columns"
        ref="DocsTab"
        id="changeTable"
        show-empty
        @row-selected="rowSelected"
        empty-text='нет записей'
    >
      <template v-slot:head(edit_field)="data">
        <div class="text-center" v-if="!isCalled">
          <b-button class="btn btn-success btn-sm" variant="info" @click="add()" title="Добавить документ">
            <b-icon icon="plus-circle-fill"></b-icon>
          </b-button>
        </div>
      </template>
      <template v-slot:cell(nameDoc)="props">
        <div class="text-center" v-if="!isCalled">
          <b-input-group>
            <b-form-select v-model="props.item.id" :options="docFilesOpt" size="sm"
                           @input="updateInfo(props.item, props.index)">
              <template v-slot:first>
                <option :value="0" disabled>-- Выберите документ --</option>
              </template>
            </b-form-select>
            <template #append>
              <b-button size="sm" @click="showFilesDialog(props.item, props.index)">
                <b-icon icon="search"/>
              </b-button>
            </template>
          </b-input-group>
        </div>
        <div v-else>
          {{ props.item.nameDoc }}
        </div>
      </template>
      <template v-slot:cell(edit_field)="props">
        <div class="text-center">
          <b-button-toolbar>
            <b-button-group class="mr-1" size="sm">
              <b-button title="Удалить" @click="deleteDoc(props.index)"
                        variant="danger" v-if="!isCalled">
                <b-icon icon="trash-fill"/>
              </b-button>
              <b-button v-if="props.item.url !== ''" variant="success" @click="downloadFile(props.item)"
                        :title="props.item.url">
                <b-icon icon="cloud-download"/>
              </b-button>
            </b-button-group>
          </b-button-toolbar>
        </div>
      </template>
    </b-table>

    <b-modal ref="filesModal" v-model="modalFilesOpened" title="Выбрать документ" size="lg" id="filesModal"
             @ok="selectDocument">
      <div class="d-block">
        <FilesForm
            :isCalled="true"
            :columns="columnsDocs"
            v-model="selectedDoc"
            @selectItem="selectDocument">
        </FilesForm>
      </div>
    </b-modal>

    <b-modal id="modal-load" centered title="Загрузка файла" v-model="modalLoadOpened"
             hide-header-close no-close-on-backdrop no-close-on-esc hide-footer>
      <p class="text-center">
        <b-spinner></b-spinner>
      </p>
    </b-modal>
  </div>
</template>

<script>
import TabItems from './TabSpr.vue'
import http from '@/http-common'
import FilesForm from '../views/Document.vue'
import global from '../utils/global'

export default {
  name: 'FileDocs',
  components: {TabItems, FilesForm},
  props: {
    ekp_id: {
      type: Number,
      default: 0
    },
    isCalled: {
      type: Boolean,
      defaut: false
    },
    forSite: {
      type: Boolean,
      default: false,
    },
    apipath: {
      type: String,
      default: null,
    },
  },
  mounted() {
    this.loadItems();
    if (!this.forSite) {
      this.loadDocFiles()
    }
  },
  data() {
    return {
      docFiles: [],
      docFilesOpt: [],
      docsEkp: [],
      selectedItem: {id: null},
      selectedDoc: null,
      modalFilesOpened: false,
      modalLoadOpened: false,
      urls: {
        save: '/ekp/docs/save',
        delete: '/ekp/docs/delete',
      },
      captionSport: {
        name: 'Документ',
        nameR: 'документ'
      },
      captiontable: '',
      columns: [
        {key: 'docType', label: 'Тип'},
        {key: 'nameDoc', label: 'Наименование документа'},
        {key: 'dateDoc', label: 'Дата'},
        {key: 'commentDoc', label: 'Описание'},
        {key: 'edit_field', label: ''}
      ],
      columnsDocs: [
        {key: 'docType', label: 'Тип документа'},
        {key: 'nameDoc', label: 'Наименование'},
        {key: 'dateDoc', label: 'Дата документа'},
        {key: 'commentDoc', label: 'Описание'},
      ],
      activeIdx: 0
    }
  },
  methods: {
    loadItems() {
      var vm = this;
      http.get('/' + this.apipath + '/' + this.ekp_id + "?forSite=" + this.forSite)
      .then((response) => {
        if (response.data && response.data !== "") {
          vm.docsEkp = response.data;
        } else {
          vm.docsEkp = []
        }
        vm.docsEkp.forEach(function (x) {
          x.url = global.getFullUrlDocument(x.keyFile);
        })
      })
      .catch((error) => console.log(error.response.data));
    },
    loadDocFiles() {
      var vm = this;
      http.get('/document/list')
      .then((response) => {
        vm.docFiles = response.data;
        vm.docFiles.forEach(function (x) {
          var opt = {value: x.id, text: x.nameDoc}
          vm.docFilesOpt.push(opt)
        })
      })
      .catch((error) => console.log(error.response.data));
    },
    add() {
      var docfile = {
        docType: '',
        nameDoc: '',
        dateDoc: '',
        commentDoc: '',
        url: '',
      };
      if (!this.docsEkp) {
        this.docsEkp = [];
      }
      this.docsEkp.push(docfile);
      // this.$emit('input', this.items)
    },
    deleteDoc(index) {
      this.docsEkp.splice(index, 1)
    },
    showFilesDialog(rec, index) {
      this.rowSelected([rec])
      this.activeIdx = index;
      this.modalFilesOpened = !this.modalFilesOpened;
    },
    selectDocument() {
      this.selectedItem.nameDoc = this.selectedDoc.nameDoc;
      this.selectedItem.docType = this.selectedDoc.docType;
      this.selectedItem.dateDoc = this.selectedDoc.dateDoc;
      this.selectedItem.commentDoc = this.selectedDoc.commentDoc;
      this.selectedItem.id = this.selectedDoc.id;
      this.modalFilesOpened = false;
      if (this.activeIdx >= 0) {
        this.docsEkp[this.activeIdx].nameDoc = this.selectedDoc.nameDoc;
        this.docsEkp[this.activeIdx].docType = this.selectedDoc.docType;
        this.docsEkp[this.activeIdx].dateDoc = this.selectedDoc.dateDoc;
        this.docsEkp[this.activeIdx].commentDoc = this.selectedDoc.commentDoc;
        this.docsEkp[this.activeIdx].id = this.selectedDoc.id;
      }
    },
    rowSelected(items) {
      for (var key in items[0]) {
        this.selectedItem[key] = items[0][key];
      }
    },
    updateInfo(value, index) {
      if (value) {
        var list = this.docFiles.filter(x => x.id === value.id);
        this.docsEkp[index].nameDoc = list[0].nameDoc;
        this.docsEkp[index].docType = list[0].docType;
        this.docsEkp[index].dateDoc = list[0].dateDoc;
        this.docsEkp[index].commentDoc = list[0].commentDoc;
        this.docsEkp[index].url = global.getFullUrlDocument(list[0].keyFile);
        //this.docsEkp[index].id = this.selectedDoc.id;
      }
    },
    saveChangesEkp() {
      http.post('/' + this.apipath + '/save/' + this.ekp_id, this.docsEkp)
      .then(() => {
        // this.modalDocumentOpened = !this.modalDocumentOpened;
      })
      .catch(error => {
        if (error.response.status === 403) {
          alert("Нет прав!")
        } else {
          alert(error.response.message)
        }
      });
    },
    downloadFile(rec) {
      var vm = this;
      this.modalLoadOpened = true;
      var exp = 'pdf';
      if (rec.keyFile && rec.keyFile.lastIndexOf(".") >= 0) {
        exp = rec.keyFile.substring(rec.keyFile.lastIndexOf(".") + 1)
      }
      http.get(rec.url,
          {
            responseType: 'blob',
          }
      ).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        var str = global.getExt(rec.nameDoc)
        if (str && str !== '') {
          link.setAttribute('download', rec.nameDoc);
        } else {
          link.setAttribute('download', rec.nameDoc + '.' + exp);
        }
        document.body.appendChild(link);
        link.click();
      })
      .catch(() => alert('Ошибка загрузки файла!'))
      .finally(() => vm.modalLoadOpened = false);
    },
  }
}
</script>

<style scoped>
#changeTable {
  font-size: 0.8em;
}
</style>
